import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
    transform(value: string, searchTerm: string): string {
        if (!value) return '';
        if (!searchTerm) return value;

        const escapedTerm = this.escapeRegExp(searchTerm);
        const regex = new RegExp(`(${escapedTerm})`, 'gi');

        const replacedBoldText = value.replace(regex, '<b>$1</b>');
        const putDefaultToSpan = replacedBoldText.replace(/([^<b>]+)(?=<b>|$)/g, '<span>$1</span>');

        return `<span>${putDefaultToSpan}</span>`;
    }

    /**
     * Escapes special characters in a string so it can be safely used in a regular expression.
     *
     * Certain characters in RegExp have special meanings:
     * . * + ? ^ $ { } ( ) | [ ] \
     * If not escaped, including them directly in a RegExp can cause syntax errors
     * or unexpected behavior.
     *
     * @param value The string to escape for use in a RegExp.
     * @returns A new string where all RegExp special characters are escaped
     *          with a backslash (\), making it safe to include in a regular expression.
     *
     * @example
     * escapeRegExp('(.*)+?[]{}$^|\\'); // '\(\.\*\)\+\?\[\]\{\}\$\^\|\\'
     * escapeRegExp('a+b*c'); // 'a\+b\*c'
     * escapeRegExp('[xyz]?'); // '\[xyz\]\?'
     */
    private escapeRegExp(value: string): string {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
}
